import React, {useEffect, useState} from "react";
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import {Grid, TextField, Typography} from "@mui/material";
import ButtonGroup from '@mui/material/ButtonGroup';
import {useNavigate, useSearchParams} from 'react-router-dom';
import useMediaQuery from '@mui/material/useMediaQuery';
import {styled, useTheme} from '@mui/material/styles';
import Button from '@mui/material/Button';
import {getCookie, setCookie} from '../utils/Functions';
import {Swiper, SwiperSlide} from 'swiper/react';
import {Autoplay} from 'swiper/modules';
import 'swiper/css';
import './Home2.css';

const ColorButton = styled(Button)(({theme}) => ({
    color: theme.palette.getContrastText("#fff"),
    fontSize: 20,
    fontWeight: "700",
    padding: 1,
    height: 65,
    borderRadius: 3,
    width: "100%",
    backgroundColor: "#ffff00",
    '&:hover': {
        backgroundColor: "#fff",
        color: "#000"
    },
}));

const Home = () => {
    const navigate = useNavigate();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const [showAmount, setShowAmount] = useState(false);
    const [error, setError] = useState("");
    const [amount, setAmount] = useState(100);
    const [searchParams] = useSearchParams();
    const [isFooterVisible, setIsFooterVisible] = useState(false);

    const BASE_URL = process.env.REACT_APP_URL_CONFIG;
    const ASSETS = `${BASE_URL}/assets/imgs/unicef/teleton2026`;

    const [finalData, setFinalData] = useState({
        utm_source: searchParams.get("utm_source") || "false",
        utm_medium: searchParams.get("utm_medium") || "false",
        utm_campaign: searchParams.get("utm_campaign") || "false",
        utm_id: searchParams.get("utm_id") || "false",
        utm_term: searchParams.get("utm_term") || "false",
        utm_content: searchParams.get("utm_content") || "false"
    });

    const handleChange = (e) => {
        if (e.target.value === "") {
            setAmount(e.target.value);
        } else if (/^[0-9]+$/.test(e.target.value)) {
            setError("");
            setAmount(e.target.value);
        }
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') donate();
    };

    const donate = () => {
        if (parseInt(amount) >= 60) {
            if (process.env.REACT_APP_URL_CONFIG === "https://www.unicef.org.bo") {
                window.fbq('track', 'AddToCart', {
                    content_type: 'product',
                    value: amount,
                    currency: "BOB"
                });
                window.gtag("event", "add_to_cart", {
                    currency: "BOB",
                    value: amount,
                    items: [{
                        item_id: "SKU_DONACION",
                        item_name: "Donación de " + amount + "Bs",
                        price: amount,
                        quantity: 1
                    }]
                });
            }
            setTimeout(() => window.scrollTo(0, 0), 100);
            navigate("/donar/" + amount);
        } else {
            setError("El monto debe ser mayor a Bs 60");
        }
    };

    useEffect(() => {
        setTimeout(() => window.scrollTo(0, 0), 100);

        let _finalData = {...finalData};
        const params = ["utm_source", "utm_medium", "utm_campaign", "utm_id", "utm_term", "utm_content"];
        params.forEach(param => {
            if (searchParams.get(param)) {
                _finalData[param] = searchParams.get(param);
            } else {
                let val = getCookie(process.env.REACT_APP_NAME + param);
                if (!val || val === "undefined" || val === "null") val = "";
                _finalData[param] = val;
            }
            setCookie(process.env.REACT_APP_NAME + param, _finalData[param], 0.5);
        });
        setTimeout(() => setFinalData(_finalData), 100);

        const handleScroll = () => setIsFooterVisible(window.scrollY > 300);
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const scrollToDonation = () => {
        document.getElementById("donation-form").scrollIntoView({behavior: "smooth"});
    };

    return (
        <>
            <div className="tda2026">
                {/* ====== DESKTOP ====== */}
                {!isMobile && (
                    <>
                        {/* Hero banner with buttons overlaid */}
                        <section className="tda2026-hero">
                            <img
                                src={`${ASSETS}/desktop.png`}
                                alt="Teletón 2026"
                                className="tda2026-hero__img"
                            />
                            <div className="tda2026-donation tda2026-donation--desktop" id="donation-form">
                                <div className="tda2026-donation__inner">
                                    <p className="tda2026-donation__title">Selecciona tu donación mensual</p>
                                    <div className="tda2026-donation__grid">
                                        <button className={`tda2026-donation__btn ${amount === 80 ? 'tda2026-donation__btn--active' : ''}`}
                                            onClick={() => { setError(""); setAmount(80); setShowAmount(false); }}>Bs 80</button>
                                        <div className="tda2026-donation__btn--popular-wrap">
                                            <span className="tda2026-donation__popular-badge">Popular</span>
                                            <div className="tda2026-donation__popular-border">
                                                <button className={`tda2026-donation__btn ${amount === 100 ? 'tda2026-donation__btn--active' : ''}`}
                                                    style={{width: '100%'}}
                                                    onClick={() => { setError(""); setAmount(100); setShowAmount(false); }}>Bs 100</button>
                                            </div>
                                        </div>
                                        <button className={`tda2026-donation__btn ${amount === 130 ? 'tda2026-donation__btn--active' : ''}`}
                                            onClick={() => { setError(""); setAmount(130); setShowAmount(false); }}>Bs 130</button>
                                        <button className={`tda2026-donation__btn ${amount !== 80 && amount !== 100 && amount !== 130 && showAmount ? 'tda2026-donation__btn--active' : ''}`}
                                            onClick={() => { setAmount(""); setShowAmount(true); }}>Otro</button>
                                    </div>
                                    {showAmount ? (
                                        <div className="tda2026-donation__amount-row">
                                            <input type="text" className="tda2026-donation__amount-input"
                                                value={amount} onChange={handleChange} onKeyDown={handleKeyDown}
                                                placeholder="Monto en Bs" autoFocus />
                                            <button className="tda2026-donation__amount-submit" onClick={donate}>Dona Ahora</button>
                                        </div>
                                    ) : (
                                        <div className="tda2026-donation__submit-row">
                                            <button className="tda2026-donation__submit-btn" onClick={donate}>DONA AHORA</button>
                                        </div>
                                    )}
                                    {error && (
                                        <div className="tda2026-donation__error">
                                            <WarningAmberIcon sx={{fontSize: "1.2rem"}} />{error}
                                        </div>
                                    )}
                                    <p className="tda2026-donation__note">*** No olvides activar tu tarjeta para compras por internet</p>
                                </div>
                            </div>
                        </section>

                    </>
                )}

                {/* ====== MOBILE ====== */}
                {isMobile && (
                    <>
                        {/* Hero banner (no overlay) */}
                        <section>
                            <img
                                src={`${ASSETS}/mobile.png`}
                                alt="Teletón 2026"
                                className="tda2026-hero__img"
                            />
                        </section>

                        {/* Donation buttons BELOW the banner (mobile style from original) */}
                        <div className="tda2026-donation-mobile" id="donation-form">
                            <Grid container spacing={0}>
                                <Grid item xs={12} style={{backgroundColor: "#FFFA2F", width: "100%"}}>
                                    <Typography
                                        sx={{mb: 2, mt: 2}}
                                        variant="h5"
                                        style={{textAlign: "center", color: "#000"}}>
                                        <span className="font-face-UniversBold">
                                            Selecciona el monto que quieres donar.
                                        </span>
                                    </Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <ColorButton style={{
                                        color: "#fff", borderRadius: 45, textTransform: "capitalize",
                                        border: "2px solid #fff",
                                        backgroundColor: amount === 80 ? "rgb(9,136,199,1)" : "rgb(9,136,199,0.5)",
                                        marginTop: "8px"
                                    }} onClick={() => { setError(""); setAmount(80); setShowAmount(false); }}
                                        variant="contained"><span className="font-face-UniversBold">Bs 80</span></ColorButton>
                                </Grid>
                                <Grid item xs={6} style={{position: "relative"}}>
                                    <div style={{
                                        position: "absolute", top: "-8px", left: "50%", transform: "translateX(-50%)",
                                        backgroundColor: "#fff", color: "#1FA3DB", padding: "4px 12px",
                                        borderRadius: "12px", fontSize: "11px", fontWeight: "bold", zIndex: 10, whiteSpace: "nowrap"
                                    }}>Popular</div>
                                    <div style={{border: "2px dashed #1FA3DB", borderRadius: "50px", padding: "4px", marginTop: "0px"}}>
                                        <ColorButton style={{
                                            color: "#fff", borderRadius: 45, textTransform: "capitalize",
                                            border: "2px solid #fff",
                                            backgroundColor: amount === 100 ? "rgb(9,136,199,1)" : "rgb(9,136,199,0.5)",
                                        }} onClick={() => { setError(""); setAmount(100); setShowAmount(false); }}
                                            variant="contained"><span className="font-face-UniversBold">Bs 100</span></ColorButton>
                                    </div>
                                    <div style={{
                                        position: "absolute", bottom: "-27px", left: "50%", transform: "translateX(-50%)",
                                        color: "#1FA3DB", fontSize: "11px", fontWeight: "bold", textAlign: "center",
                                        zIndex: 10, whiteSpace: "nowrap", lineHeight: "1"
                                    }}>
                                        <div style={{fontSize: "24px", marginBottom: "-2px"}}>&#9660;</div>
                                        Opción más elegida
                                    </div>
                                </Grid>
                                <Grid item xs={6} style={{marginTop: "30px"}}>
                                    <ColorButton style={{
                                        color: "#fff", borderRadius: 45, textTransform: "capitalize",
                                        border: "2px solid #fff",
                                        backgroundColor: amount === 130 ? "rgb(9,136,199,1)" : "rgb(9,136,199,0.5)",
                                    }} onClick={() => { setError(""); setAmount(130); setShowAmount(false); }}
                                        variant="contained"><span className="font-face-UniversBold">Bs 130</span></ColorButton>
                                </Grid>
                                <Grid item xs={6} style={{marginTop: "30px"}}>
                                    <ColorButton style={{
                                        color: "#fff", borderRadius: 45, textTransform: "capitalize",
                                        border: "2px solid #fff",
                                        backgroundColor: amount !== 80 && amount !== 100 && amount !== 130 ? "rgb(9,136,199,1)" : "rgb(9,136,199,0.5)",
                                        fontSize: "1.1rem", lineHeight: "1"
                                    }} onClick={() => { setAmount(130); setShowAmount(true); }}
                                        variant="contained"><span className="font-face-UniversBold">Otro Monto Mayor</span></ColorButton>
                                </Grid>
                                <Grid item xs={12} style={{textAlign: "center", marginTop: "20px", marginBottom: "20px"}}>
                                    {showAmount ? (
                                        <ButtonGroup style={{width: "100%"}} disableElevation variant="contained">
                                            <TextField style={{width: "50%"}} className="amount-text"
                                                value={amount} onChange={handleChange} onKeyDown={handleKeyDown} />
                                            <ColorButton onClick={donate} style={{width: "50%", backgroundColor: "#FFFA2F", color: "#000"}}>
                                                <span className="font-face-UniversBold">Dona Ahora</span>
                                            </ColorButton>
                                        </ButtonGroup>
                                    ) : (
                                        <ColorButton style={{borderRadius: 35, width: "50%", backgroundColor: "#FFFA2F", color: "#000"}}
                                            onClick={donate}>Dona Ahora</ColorButton>
                                    )}
                                </Grid>
                                {error !== "" && (
                                    <Grid item xs={12} mt={1}>
                                        <div style={{
                                            background: "#000", zIndex: "99", fontSize: "1rem", fontWeight: 600,
                                            textAlign: "center", color: "#fff", padding: 5, borderRadius: 5
                                        }}>
                                            <WarningAmberIcon sx={{fontSize: "2rem", marginRight: 1}} />{error}
                                        </div>
                                    </Grid>
                                )}
                            </Grid>
                        </div>
                    </>
                )}

                {/* ====== PAGE BODY SECTIONS (shared desktop/mobile) ====== */}

                {/* Section 1: Problem - 4 de cada 10 */}
                <section className="tda2026-problem">
                    <div className="tda2026-problem__inner">
                        <div className="tda2026-problem__photo-wrap">
                            <img src={`${ASSETS}/girl-poverty.png`} alt="Niña boliviana" className="tda2026-problem__photo" />
                        </div>
                        <div className="tda2026-problem__content">
                            <div className="tda2026-problem__stat">
                                <span className="tda2026-problem__stat-number">4</span>
                                <span className="tda2026-problem__stat-middle">
                                    <span className="tda2026-problem__stat-de">de</span>
                                    <span className="tda2026-problem__stat-cada">cada</span>
                                </span>
                                <span className="tda2026-problem__stat-number">10</span>
                            </div>
                            <p className="tda2026-problem__headline">
                                niñas, niños y adolescentes en Bolivia viven en situación de pobreza multidimensional
                            </p>
                            <p className="tda2026-problem__desc">
                                y las brechas en salud, educación, protección y acceso a servicios básicos presentan indicadores negativos.
                            </p>
                        </div>
                    </div>
                </section>

                {/* Section 2: Prizes */}
                <section className="tda2026-prizes">
                    <img src={`${ASSETS}/heart-light.png`} alt="" className="tda2026-prizes__bg" aria-hidden="true" />
                    <div className="tda2026-prizes__inner">
                        <h2 className="tda2026-prizes__title">
                            Con tu donación mensual participas del sorteo de <span>grandes premios.</span>
                        </h2>

                        {/* Desktop: composite image */}
                        {!isMobile && (
                            <img src={`${ASSETS}/premios-landing.png`} alt="Premios" className="tda2026-prizes__img" />
                        )}

                        {/* Mobile: car at top + carousel of other prizes */}
                        {isMobile && (
                            <div className="tda2026-prizes-mobile">
                                <div className="tda2026-prizes-mobile__main">
                                    <img src={`${ASSETS}/prizes/auto.png`} alt="Suzuki Alto 0Km" className="tda2026-prizes-mobile__car" />
                                    <p className="tda2026-prizes-mobile__car-label">Suzuki Alto 0Km</p>
                                </div>
                                <Swiper
                                    modules={[Autoplay]}
                                    slidesPerView={2.5}
                                    spaceBetween={15}
                                    loop={true}
                                    autoplay={{delay: 2500, disableOnInteraction: false}}
                                    className="tda2026-prizes-mobile__carousel"
                                >
                                    {[
                                        {img: 'pasajes.png', label: 'Paquete vacacional'},
                                        {img: 'poliza.png', label: 'Póliza automotriz'},
                                        {img: 'peya2.png', label: 'Vales Pedidos Ya'},
                                        {img: 'polera-1.jpg', label: 'Polera Messi'},
                                        {img: 'poleras-grupo.png', label: 'Poleras autografiadas'},
                                        {img: 'hervidora.png', label: 'Hervidores eléctricos'},
                                        {img: 'tostadora.png', label: 'Tostadoras'},
                                        {img: 'vales-consumo.png', label: 'Vales de consumo'},
                                    ].map((prize, i) => (
                                        <SwiperSlide key={i}>
                                            <div className="tda2026-prizes-mobile__item">
                                                <img src={`${ASSETS}/prizes/${prize.img}`} alt={prize.label} className="tda2026-prizes-mobile__item-img" />
                                                <p className="tda2026-prizes-mobile__item-label">{prize.label}</p>
                                            </div>
                                        </SwiperSlide>
                                    ))}
                                </Swiper>
                            </div>
                        )}

                        <div className="tda2026-prizes__list-wrap">
                            <p className="tda2026-prizes__list-title">Lista de premios</p>
                            <Swiper
                                modules={[Autoplay]}
                                direction="vertical"
                                slidesPerView={3}
                                spaceBetween={0}
                                loop={true}
                                loopAdditionalSlides={3}
                                autoplay={{delay: 1000, disableOnInteraction: false, pauseOnMouseEnter: true}}
                                speed={400}
                                className="tda2026-prizes__ticker"
                            >
                                {[
                                    '1 Suzuki Alto modelo 2027 (0 Km)',
                                    '1 paquete vacacional al caribe para 2 personas todo pagado (incluye Pasajes de avión)',
                                    '1 póliza automotriz',
                                    '10 vales de consumo de Pedidos Ya por Bs. 1.000 cada uno',
                                    '1 polera del FC Barcelona (temporada 2021) autografiada por Lionel Messi (con certificado de autenticidad)',
                                    '1 polera autografiada de la selección boliviana',
                                    '1 polera autografiada del club Bolivar',
                                    '1 polera autografiada del club The Strongest',
                                    '1 polera autografiada del club Oriente Petrolero',
                                    '1 polera autografiada del club Blooming',
                                    '5 hervidores eléctricos de 1.7 L marca Masterpro',
                                    '2 tostadoras de 2 rebanadas marca Masterpro',
                                    '2 vales de consumo de Bs. 500 cada uno del restaurante Caudila (Santa Cruz)',
                                    '2 vales de consumo de Bs. 500 cada uno del restaurante El Arriero (Santa Cruz)',
                                ].map((prize, i) => (
                                    <SwiperSlide key={i}>
                                        <div className="tda2026-prizes__ticker-item">
                                            <span className="tda2026-prizes__ticker-bullet">&#9733;</span>
                                            <span>{prize}</span>
                                        </div>
                                    </SwiperSlide>
                                ))}
                            </Swiper>
                        </div>
                    </div>
                </section>

                {/* Section 3: Water / Rural */}
                <section className="tda2026-water">
                    <div className="tda2026-water__inner">
                        <div className="tda2026-water__content">
                            <p className="tda2026-water__intro">En varias comunidades rurales,</p>
                            <div className="tda2026-water__stat">
                                <span className="tda2026-water__stat-number">4</span>
                                <span className="tda2026-water__stat-middle">
                                    <span className="tda2026-water__stat-de">de</span>
                                    <span className="tda2026-water__stat-cada">cada</span>
                                </span>
                                <span className="tda2026-water__stat-number">10</span>
                            </div>
                            <p className="tda2026-water__headline">
                                familias todavía no cuentan con agua potable en su hogar.
                            </p>
                        </div>
                        <div className="tda2026-water__photo-wrap">
                            <img src={`${ASSETS}/girl-water.png`} alt="Niña con agua" className="tda2026-water__photo" />
                        </div>
                    </div>
                    <div className="tda2026-water__cta-bar">
                        <p className="tda2026-water__cta-text">En tus manos está cambiar sus vidas</p>
                        <button className="tda2026-cta" onClick={scrollToDonation}>DONA AHORA &gt;</button>
                    </div>
                </section>

                {/* Section 4: Impact Areas */}
                <section className="tda2026-impact">
                    <div className="tda2026-impact__inner">
                        <h2 className="tda2026-impact__title">
                            Todo lo recaudado contribuirá a que <span>UNICEF</span> llegue a miles de niñas, niños y adolescentes:
                        </h2>
                        <div className="tda2026-impact__grid">
                            <div className="tda2026-impact__card">
                                <img src={`${ASSETS}/icon-health.png`} alt="" className="tda2026-impact__card-icon" />
                                <p className="tda2026-impact__card-stat">Más de 1.200.000 niñas y niños</p>
                                <p className="tda2026-impact__card-desc">recibirán vitamina A, para fortalecer su sistema inmunológico justo en la etapa más importante de su desarrollo.</p>
                            </div>
                            <div className="tda2026-impact__card">
                                <img src={`${ASSETS}/icon-protection.png`} alt="" className="tda2026-impact__card-icon" />
                                <p className="tda2026-impact__card-stat">Más de 100.000 niñas y niños</p>
                                <p className="tda2026-impact__card-desc">menores de cinco años serán alcanzados por brigadas de vacunación, que <strong>llevan protección hasta las comunidades donde hoy es más difícil llegar.</strong></p>
                            </div>
                            <div className="tda2026-impact__card">
                                <img src={`${ASSETS}/icon-education.png`} alt="" className="tda2026-impact__card-icon" />
                                <p className="tda2026-impact__card-stat">Más de 13.000 niñas y niños</p>
                                <p className="tda2026-impact__card-desc">accederán a <strong>servicios de detección y estimulación temprana</strong> del desarrollo.</p>
                            </div>
                            <div className="tda2026-impact__card">
                                <img src={`${ASSETS}/icon-water.png`} alt="" className="tda2026-impact__card-icon" />
                                <p className="tda2026-impact__card-stat">Más de 9.800 niñas, niños y adolescentes</p>
                                <p className="tda2026-impact__card-desc">que hoy enfrentan situaciones de violencia <strong>recibirán atención, protección y acompañamiento.</strong></p>
                            </div>
                            <div className="tda2026-impact__card tda2026-impact__card--wide">
                                <img src={`${ASSETS}/icon-family.png`} alt="" className="tda2026-impact__card-icon" />
                                <p className="tda2026-impact__card-stat">Más de 1.600 familias</p>
                                <p className="tda2026-impact__card-desc">en situación de vulnerabilidad <strong>recibirán las herramientas y la orientación</strong> que necesitan para acompañar el desarrollo de sus hijas e hijos en casa.</p>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Section 5: Final CTA */}
                <section className="tda2026-final-cta">
                    <button className="tda2026-cta" onClick={scrollToDonation}>DONA AHORA &gt;</button>
                </section>

                {/* Section 6: Sponsors */}
                <section className="tda2026-sponsors">
                    <div className="tda2026-sponsors__inner">
                        <p className="tda2026-sponsors__title">Con el apoyo de:</p>
                        {isMobile ? (
                            <Swiper
                                modules={[Autoplay]}
                                slidesPerView={3}
                                spaceBetween={20}
                                loop={true}
                                autoplay={{delay: 2000, disableOnInteraction: false}}
                                className="tda2026-sponsors__carousel"
                            >
                                {[
                                    {file: '01-suzuki.png', alt: 'Suzuki'},
                                    {file: '02-imcruz.png', alt: 'Imcruz'},
                                    {file: '03-entel.png', alt: 'Entel'},
                                    {file: '04-bisa-seguros.png', alt: 'BISA Seguros'},
                                    {file: '05-estropical.png', alt: 'EsTropical'},
                                    {file: '06-expocruz.png', alt: 'Expocruz'},
                                    {file: '07-finesse.png', alt: 'Finesse'},
                                    {file: '08-fundacion-vida.png', alt: 'Fundación Nacional Vida'},
                                    {file: '09-banco-bisa.png', alt: 'Banco BISA'},
                                    {file: '10-haka-group.png', alt: 'Haka Group'},
                                    {file: '11-los-tajibos.png', alt: 'Los Tajibos'},
                                    {file: '12-nexocorp-farmacorp.png', alt: 'Nexocorp Farmacorp'},
                                    {file: '13-banco-economico.png', alt: 'Banco Económico'},
                                    {file: '14-pedidos-ya.png', alt: 'Pedidos Ya'},
                                ].map((logo, i) => (
                                    <SwiperSlide key={i}>
                                        <img src={`${ASSETS}/sponsors/${logo.file}`} alt={logo.alt} className="tda2026-sponsors__logo" />
                                    </SwiperSlide>
                                ))}
                            </Swiper>
                        ) : (
                            <div className="tda2026-sponsors__grid">
                                {[
                                    {file: '01-suzuki.png', alt: 'Suzuki'},
                                    {file: '02-imcruz.png', alt: 'Imcruz'},
                                    {file: '03-entel.png', alt: 'Entel'},
                                    {file: '04-bisa-seguros.png', alt: 'BISA Seguros'},
                                    {file: '05-estropical.png', alt: 'EsTropical'},
                                    {file: '06-expocruz.png', alt: 'Expocruz'},
                                    {file: '07-finesse.png', alt: 'Finesse'},
                                    {file: '08-fundacion-vida.png', alt: 'Fundación Nacional Vida'},
                                    {file: '09-banco-bisa.png', alt: 'Banco BISA'},
                                    {file: '10-haka-group.png', alt: 'Haka Group'},
                                    {file: '11-los-tajibos.png', alt: 'Los Tajibos'},
                                    {file: '12-nexocorp-farmacorp.png', alt: 'Nexocorp Farmacorp'},
                                    {file: '13-banco-economico.png', alt: 'Banco Económico'},
                                    {file: '14-pedidos-ya.png', alt: 'Pedidos Ya'},
                                ].map((logo, i) => (
                                    <img key={i} src={`${ASSETS}/sponsors/${logo.file}`} alt={logo.alt} className="tda2026-sponsors__logo" />
                                ))}
                            </div>
                        )}
                    </div>
                </section>
            </div>

            {/* Sticky footer */}
            {isFooterVisible && (
                <footer className="tda2026-sticky-footer">
                    <div className="tda2026-sticky-footer__inner">
                        <p className="tda2026-sticky-footer__text">
                            Ayuda a miles de niños y participa del sorteo de un auto 0km
                        </p>
                        <button className="tda2026-sticky-footer__btn" onClick={scrollToDonation}>
                            DONA AHORA
                        </button>
                    </div>
                </footer>
            )}
        </>
    );
};

Home.propTypes = {};

export default Home;
